import React, { Component, Fragment } from 'react';
import axios from 'axios';
import { Button } from 'antd';
import { withAsyncActions } from 'react-async-client';
import { find, propEq } from 'ramda';

import { getProducts, addCheck, sendSms } from 'actions/asyncActions';
import ApplicationFiles from './ApplicationFiles';

@withAsyncActions({
    getProducts: getProducts.withOptions({ dispatchOnMount: true }),
    addCheck,
    sendSms,
})
export default class ApplicationSpecTable extends Component {
    state = {
        mateiralsOpen: false,
        codeValue: '',
        showSmsBlock: false,
        wrongCode: false
    }

    sendSms = () => {
        this.setState({
            codeValue: '',
            showSmsBlock: true,
            wrongCode: false
        });
        this.props.sendSms.dispatch();
    }

    changeCodeValue = (e) => {
        const value = e.target.value || '';
        const code = (value.match(/\d/g) || []).join('').slice(0, 4);
        this.setState({
            codeValue: code
        });
    }

    acceptApplication = () => {
        axios.patch('user/applications/status_offer/' + this.props.application.id, {
            status_offer: 'APPROVED',
            code: this.state.codeValue
        }).then(() => {
            this.props.onAccept();
        }).catch((e) => {
            this.setState({
                wrongCode: e.data.error === "SMS VERIFICATION ERROR"
            });
        });
        this.setState({
            codeValue: '',
            wrongCode: false
        })
    }

    declineApplication = () => {
        axios.patch('user/applications/status_offer/' + this.props.application.id, {
            status_offer: 'REJECTED'
        }).then(() => {
            this.props.onAccept();
        });
    }

    acceptSpecification = () => {
        axios.patch('user/applications/status_specification/' + this.props.application.id, {
            status_specification: 'APPROVED'
        }).then(() => {
            this.props.onAccept();
        });

    }

    declineSpecification = () => {
        axios.patch('user/applications/status_specification/' + this.props.application.id, {
            status_specification: 'REJECTED'
        }).then(() => {
            this.props.onAccept();
        });
    }

    handleCheckUpload = (e) => {
        const check = e.target.files[0];
        if (check) {
            this.props.addCheck.dispatch({
                check,
                application: this.props.application.id
            })
        }
    }

    toggleMateiralsOpen = () => {
        this.setState({
            mateiralsOpen: !this.state.mateiralsOpen
        });
    }

    downloadSpecification = () => {
        const { application } = this.props;
        document.location.assign(`http://apilegrand.beapps.ru${application.specification_file}`);
    }

    downloadOffer = () => {
        const { application } = this.props;
        document.location.assign(`http://apilegrand.beapps.ru${application.offer_file}`);
    }

    columns = [
        {
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
            className: 'bold',
        },
        {
            title: 'Название',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Кат. №',
            dataIndex: 'cat',
            key: 'cat',
        },
        {
            title: 'Кол-во',
            dataIndex: 'quantity',
            key: 'quantity',
        },
        {
            title: 'Место установки',
            dataIndex: 'place',
            key: 'place',
        },
    ];

    render() {
        const { project, application } = this.props;
        const { data = {} } = this.props.getProducts;
        const { meta: checkMeta } = this.props.addCheck;
        const specs = [];
        if (data.products) {
            application.frames_ids.forEach(id => {
                const frame = find(propEq('id', id), data.products.frames);
                const inserted = find(propEq('id', id), specs);

                if (!inserted) {
                    frame && specs.push({
                        ...frame,
                        quantity: 1
                    });
                } else {
                    inserted.quantity++;
                }
            });
            application.funcs_ids.forEach(id => {
                const func = find(propEq('id', id), data.products.funcs);
                const inserted = find(propEq('id', id), specs);

                if (!inserted) {
                    func && specs.push({
                        ...func,
                        quantity: 1
                    });
                } else {
                    inserted.quantity++;
                }
            });
        }

        return !project || !application ? null : (
            <Fragment>
                <ApplicationFiles project={project} application={application} />

                {application.status === 'OFFER_APPROVED' && (!checkMeta.lastSucceedAt && !application.check_file) && (
                    <div className="m-b-20 xs-p-20">
                        <Button type="primary">
                            <label>
                                Прикрепите фото чека
                                <input type="file" onChange={this.handleCheckUpload} disabled={checkMeta.pending} hidden />
                            </label>
                        </Button>
                    </div>
                )}

                {application.status === 'OFFER_APPROVED' && (checkMeta.success || Boolean(application.check_file)) && (
                    <div className="m-b-20 xs-p-20">
                        Фото чека загружено
                    </div>
                )}

                {isEditable(application.status) && false && (<div className="controls xs-p-20">
                    <Button type="primary">
                        Сохранить и отправить заявку
                    </Button>
                </div>)}
            </Fragment>
        );
    }
}

function isEditable(status) {
    return [
        'SENT',
        'SPECIFICATION_CREATED',
        'SPECIFICATION_REJECTED'
    ].some(s => s === status);
}



// WEBPACK FOOTER //
// ./src/components/pages/projects/application/ApplicationSpecTable.js